define(['ko', '_', 'bindings/stopBinding', 'bindings/numeric'], function(ko, _) {
    return function layout(isLoggedIn) {
        var self = this;
        self.searchTerm = ko.observable("");
        self.pendingOrders = ko.observable(0);
        self.doBounce = ko.observable(false);
        self.loader = ko.observable(0);
        
        if(isLoggedIn) {
            // let source = new EventSource("/notifications/sse");
            // source.onerror = (err) => console.error("EventSource connection failed:", err);
            //
            // source.onopen = function (event) {
            //     //
            // }
            // source.onmessage = function (event) {
            //     self.pendingOrders(parseInt(event.data, 10));
            //     // removes "bounce" class which runs the animation once
            //     self.doBounce(false);
            //     // add the "bounce" class after 50 ms to run the animation again
            //     new Promise(resolve => setTimeout(resolve, 50)).then(() => self.doBounce(true));
            //
            //     if (event.id === "CLOSE") {
            //         source.close();
            //     }
            // }
        }
    }
});
